import { None, Optional } from "./typeUtilities";

import { EmotionName } from "../data/emotion";

export type EmotionInfo = {
  name: EmotionName;
  descriptor: Optional<string>;
};

export const CANONICAL_EMOTION_NAMES: EmotionName[] = [
  "Admiration",
  "Adoration",
  "Aesthetic Appreciation",
  "Amusement",
  "Anger",
  "Anxiety",
  "Awe",
  "Awkwardness",
  "Boredom",
  "Calmness",
  "Concentration",
  "Confusion",
  "Contemplation",
  "Contempt",
  "Contentment",
  "Craving",
  "Desire",
  "Determination",
  "Disappointment",
  "Disgust",
  "Distress",
  "Doubt",
  "Ecstasy",
  "Embarrassment",
  "Empathic Pain",
  "Entrancement",
  "Envy",
  "Excitement",
  "Fear",
  "Guilt",
  "Horror",
  "Interest",
  "Joy",
  "Love",
  "Nostalgia",
  "Pain",
  "Pride",
  "Realization",
  "Relief",
  "Romance",
  "Sadness",
  "Satisfaction",
  "Shame",
  "Surprise (negative)",
  "Surprise (positive)",
  "Sympathy",
  "Tiredness",
  "Triumph",
];

const DESCRIPTOR_MAP: Map<EmotionName, Optional<string>> = new Map([
  ["Admiration", "Admiring"],
  ["Adoration", "Adoring"],
  ["Aesthetic Appreciation", None],
  ["Amusement", "Amused"],
  ["Anger", "Angry"],
  ["Anxiety", "Anxious"],
  ["Awe", None],
  ["Awkwardness", "Awkward"],
  ["Boredom", "Bored"],
  ["Calmness", "Calm"],
  ["Concentration", None],
  ["Confusion", "Confused"],
  ["Contemplation", "Comptemplative"],
  ["Contempt", "Contemptful"],
  ["Contentment", "Contented"],
  ["Craving", "Craving"],
  ["Desire", "Desirous"],
  ["Determination", "Determined"],
  ["Disappointment", "Disappointed"],
  ["Disgust", "Disgusted"],
  ["Distress", "Distressed"],
  ["Doubt", "Doubtful"],
  ["Ecstasy", "Ecstatic"],
  ["Embarrassment", "Embarrassed"],
  ["Empathic Pain", None],
  ["Entrancement", "Entranced"],
  ["Envy", "Envious"],
  ["Excitement", "Excited"],
  ["Fear", "Fearful"],
  ["Guilt", "Guilty"],
  ["Horror", "Horrified"],
  ["Interest", "Interested"],
  ["Joy", "Joyful"],
  ["Love", "Loving"],
  ["Nostalgia", "Nostalgic"],
  ["Pain", "Pained"],
  ["Pride", "Prideful"],
  ["Realization", None],
  ["Relief", "Relieved"],
  ["Romance", "Romantic"],
  ["Sadness", "Sad"],
  ["Satisfaction", "Satisfied"],
  ["Shame", "Shameful"],
  ["Surprise (negative)", "Surprised"],
  ["Surprise (positive)", "Surprised"],
  ["Sympathy", "Sympathetic"],
  ["Tiredness", "Tired"],
  ["Triumph", "Triumphant"],
]);

export function getEmotionDescriptor(name: EmotionName): Optional<string> {
  return DESCRIPTOR_MAP.get(name);
}
